export enum AngularBlockListType {
  StudentCoursesAndTimeTableCalendarBlockList = 1,
  ExamsAndTasksCalendarBlockList = 2,
  StudentAllGradesDetailedListViewBlockList = 3,
  StudentRecentInformationListViewBlockList = 4,
  StudentGradesSummaryBlockList = 5,
  StudentExamsAndTasksListViewBlockList = 6,
  PortalVideoWithDescriptionBlockList = 7,
  PortalPromotedInfoBlockList = 8,
  PortalEventsBlockList = 9,
  PortalSupportInfoBlockList = 10,
  PortalCareerPromotedContentBlockList = 11,
  PortalOrganizationalServicesBlockList = 12,
  PortalContentFooterBlockList = 13,
  EventsBlockBlockList = 14,
  MessageBlockList = 15,
  PortalLinksBlockList = 16,
  PortalQuestionAndAnswerBlockList = 17,
  AdditionalLinksBlockList = 18,
  PortalAngularBillingInfo = 19,
  StudentCoursesAndScheduleBlockList = 20,
  StudentAllCoursesBlockList = 21,
  CareerLatestJobs = 22,
  SuccessStoriesCubesAngularBlockList = 23,
  CollaborationsAngularBlockList = 24,
}